module.exports = __webpack_public_path__ + "img/head.301ea1f5.png";